import { CAlert, CButton, CCol, CContainer, CRow } from '@coreui/react';
import React from 'react';
import { ManagedError } from '@cloudflare-monorepo/utils/errors';
import { cilXCircle } from '@coreui/icons';
import CIcon from '@coreui/icons-react';

export const CriticalFailure = (props: { err?: unknown }) => {
  let errorMessage: string = 'Errore imprevisto. Prova a ricaricare la pagina.';
  if (props?.err) {
    if (props.err instanceof ManagedError) {
      errorMessage = props.err.message;
    } else if (typeof props.err === 'string') {
      errorMessage = props.err;
    }
  }

  let targetURL = '#';
  if (window.location.href?.length) {
    const parsed = new URL(window.location.href);
    parsed.pathname = '/';
    parsed.search = '';
    targetURL = parsed.toString();
  }

  return (
    <>
      <div className="body flex-grow-1" id="placeholderPageLoading">
        <CContainer className="px-4" lg>
          <CRow>
            <CCol>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CAlert color="danger">
                  <p>
                    <CIcon icon={cilXCircle} className="me-2" />
                    Qualcosa è andato storto!
                    <br />
                    <br />
                    {errorMessage}
                    <br />
                    <br />
                    prova a{' '}
                    <CButton size="sm" color="secondary" href={targetURL}>
                      ricaricare la pagina
                    </CButton>
                  </p>
                </CAlert>
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </>
  );
};
